<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>{{$t('fota.title')}}</h2>
        <div class="irinox-form fota" >
          <div class="search-bar" style="float: right">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('fota.search')" style="width:70px" :aria-label="$t('fota.search')"/>
            <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <Dropdown id="category" v-model="filters['category'].value" :options="categories" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_category_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="modelNumber" v-model="filters['modelNumber'].value" :options="modelNumbers" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_model_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="country" v-model="filters['country'].value" :options="countries" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_country_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="firmwareVersions" v-model="filters['firmwareDesired'].value" :options="firmwareVersions" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_firmware_ph')" />
            </div>
            <div v-if="!single" class="p-field">
              <Dropdown id="domains" v-model="filters['brandName'].value" :options="domains" optionLabel="name" optionValue="code"
                :placeholder="$t('fota.filter_brand_ph')" />
            </div>
            <div class="p-field">
              <ToggleButton v-model="single" :onLabel="$t('fota.filter_single')" :offLabel="$t('fota.filter_global')"  :disabled="false" :aria-label="$t('fota.filter_single') + ' / ' + $t('fota.filter_global')"/>      
            </div>
          </div>
        
          <DataTable :value="firmwares" stripedRows 
            v-model:filters="filters" responsiveLayout="stack" 
            breakpoint="960px"
            :autoLayout="true" :sortField="single?'serialNumber':'modelNumber'" :sortOrder="1">
            <template #empty>
                {{$t('fota.empty_list')}}
            </template>

            <Column v-if="single" field="serialNumber" :header="$t('fota.col_serialNumber')" ></Column>
            <Column field="category" :header="$t('fota.col_category')" >
              <template #body="slotProps">
                <span>{{$t('dashboard.categories.'+slotProps.data.category)}}</span>
              </template>
            </Column>
            <Column field="modelNumber" :header="$t('fota.col_model')" >
              <template #body="slotProps">
                <div>
                  {{$functions.fixModelName(slotProps.data.modelNumber)}} 
                </div>
              </template>
            </Column>
            <Column field="country" :header="$t('fota.col_country')" >
              <template #body="slotProps">
                <span v-if="single">{{getCountryName(slotProps.data.country)}}</span>
                <span v-else :class="{'fota-all':!slotProps.data.country}">{{!slotProps.data.country?$t('fota.all'):getCountryName(slotProps.data.country)}}</span>
              </template>
            </Column>
            <Column field="brandName" :header="$t('fota.col_brand')" >
              <template #body="slotProps">
                <span v-if="single">{{slotProps.data.brandName}}</span>
                <span v-else :class="{'fota-all':!slotProps.data.brandName}">{{!slotProps.data.brandName?$t('fota.all'):slotProps.data.brandName}}</span>
              </template>
            </Column>
            <Column v-if="single" field="firmwareCurrent" :header="$t('fota.col_firmware_current')" ></Column>
            <Column field="firmwareDesired" :header="$t('fota.col_firmware_desired')" >
              <template #body="slotProps">
                <span :class="{'desired':single}">{{slotProps.data.firmwareDesired}}</span>
              </template>
            </Column>

            <Column bodyClass="" class="irinox-table-buttons p-text-right">
              <template #header>
                <span class="sr-only">{{$t('common.actions')}}</span>
              </template>
              <template #body="slotProps">
                <div class="button-body">
                  <img src="assets/irinox/icons/update.svg" @click="updateFota(slotProps.data.original)" v-tooltip.left="$t('fota.tooltip_fota')" :alt="$t('fota.tooltip_fota')"/>
                </div>
              </template>
            </Column>
          </DataTable>
        
        
        </div>
		</div>
	</div>

  
  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('fota.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />

  
  <!--            -->
  <!-- MANAGE     -->
  <!--            -->
  <FotaManage :visible="dialog.manage" 
    :single="single"
    :item="selected"
    @update:visible="dialog.manage = $event" 
    @click:button="save" />
  <IrinoxDialogDark :visible="dialog.manageSuccess" 
    mode="success" 
    :message="$t('fota.manage_fw.success')"
    :life="3000" 
    @update:visible="dialog.manageSuccess = $event" />

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import CountryService from '../../service/CountryService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import FotaManage from './FotaManage.vue';
import { mapGetters } from 'vuex';
import {FilterMatchMode} from 'primevue/api';
export default {
    components: {
        IrinoxDialogDark,
        FotaManage,
    },
    data() {
        return {
          countryList: [],
          filters: null,
          single: false,
          categories: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          modelNumbers: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          countries: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          domains: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          firmwareVersions: [{ 
              code: null,
              name: this.$t('fota.filter_remove') 
            }],
          firmwares: [],
          selected: null,
          dialog: {
            error: false,
            manage: false,
            manageSuccess: false,
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
        }),
    },
    watch: {
      single: 'singleGlobalToggle'
    },
    created() {
      this.countryService = new CountryService();
      this.applianceService = new ApplianceService();
      this.initFilters();
    },
    mounted() {
      this.countryService.getCountries().then((countries) => {
          this.countryList = countries;
      });
      this.singleGlobalToggle();
    },
    methods: {
      reloadGlobal() {
        this.firmwares = [];
        let cs = [];
        let mns = [];
        let fs = [];
        let ds = [];
        let cos = [];
        this.applianceService.getFotaModels(this.personaltoken)
          .then((firmwares) => {
            for(let i=0; i<firmwares.length; i++) {
              let modelNumberTemp = firmwares[i].name + (firmwares[i].accessory?" - "+firmwares[i].accessory:"");
              this.firmwares.push({
                category: firmwares[i].type,
                modelNumber: modelNumberTemp,
                country: firmwares[i].country === "ALL" ? null : firmwares[i].country,
                brandName: firmwares[i].brand,
                firmwareDesired: firmwares[i].desiredFirmware.version,
                original: firmwares[i]
              });
              cs.push({ code: firmwares[i].type, name: this.$t('dashboard.categories.'+firmwares[i].type) });
              mns.push({ code: modelNumberTemp, name: this.$functions.fixModelName(modelNumberTemp) });
              fs.push({ code: firmwares[i].desiredFirmware.version, name: firmwares[i].desiredFirmware.version });
              if(firmwares[i].brand) {
                ds.push({ code: firmwares[i].brand, name: firmwares[i].brand });
              }
              if(firmwares[i].country && firmwares[i].country !== "ALL") {
                let country = this.countryList.find(obj => obj.code === firmwares[i].country);
                cos.push({ code: firmwares[i].country, name: country ? country.name : firmwares[i].country });
              }
            }
            this.fillFilters(cs, mns, fs, ds, cos);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.firmwares = [];
            this.fillFilters(cs, mns, fs, ds, cos);
          });
      },
      reloadSingle() {
        this.firmwares = [];
        let cs = [];
        let mns = [];
        let fs = [];
        let ds = [];
        let cos = [];
        this.applianceService.getFotaAppliances(this.personaltoken)
          .then((firmwares) => {
            for(let i=0; i<firmwares.length; i++) {
              let modelNumberTemp = firmwares[i].modelNumber + (firmwares[i].accessory?" - "+firmwares[i].accessory:"");
              this.firmwares.push({
                serialNumber: firmwares[i].serialNumber,
                category: firmwares[i].type,
                modelNumber: modelNumberTemp,
                country: firmwares[i].country,
                brandName: firmwares[i].brandName,
                firmwareCurrent: firmwares[i].currentFirmware,
                firmwareDesired: firmwares[i].desiredFirmware.version,
                original: firmwares[i]
              });
              cs.push({ code: firmwares[i].type, name: this.$t('dashboard.categories.'+firmwares[i].type) });
              mns.push({ code: modelNumberTemp, name: this.$functions.fixModelName(modelNumberTemp) });
              fs.push({ code: firmwares[i].desiredFirmware.version, name: firmwares[i].desiredFirmware.version });
              if(firmwares[i].country) {
                let country = this.countryList.find(obj => obj.code === firmwares[i].country);
                cos.push({ code: firmwares[i].country, name: country ? country.name : firmwares[i].country });
              }
            }
            this.fillFilters(cs, mns, fs, ds, cos);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.firmwares = [];
            this.fillFilters(cs, mns, fs, ds, cos);
          });
      },
      initFilters() {
        this.filters = {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'category': {value: null, matchMode: FilterMatchMode.EQUALS},
              'modelNumber': {value: null, matchMode: FilterMatchMode.EQUALS},
              'country': {value: null, matchMode: FilterMatchMode.EQUALS},
              'brandName': {value: null, matchMode: FilterMatchMode.EQUALS},
              'firmwareDesired': {value: null, matchMode: FilterMatchMode.EQUALS}
          }
      },
      emptyFilter() {
        return { 
              code: null,
              name: this.$t('fota.filter_remove') 
            };
      },
      fillFilters(cs, mns, fs, ds, cos) {
        this.categories = this.$functions.uniqByKeepFirst(cs, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.modelNumbers = this.$functions.uniqByKeepFirst(mns, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.firmwareVersions = this.$functions.uniqByKeepFirst(fs, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.domains = this.$functions.uniqByKeepFirst(ds, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.countries = this.$functions.uniqByKeepFirst(cos, item => item.code).sort((a,b) => this.$functions.compareStrings(a,b,'name'));
        this.categories.unshift(this.emptyFilter());
        this.modelNumbers.unshift(this.emptyFilter());
        this.firmwareVersions.unshift(this.emptyFilter());
        this.domains.unshift(this.emptyFilter());
        this.countries.unshift(this.emptyFilter());
      },
      singleGlobalToggle() {
        this.initFilters();
        if(this.single) {
          this.reloadSingle();
        } else {
          this.reloadGlobal();
        }
      },
      getCountryName(code) {
        let country = this.countryList.find(obj => obj.code === code);
        if(country && country.name) {
          return country.name;
        }
        return code;
      },
      updateFota(item) {
        this.selected = item;
        this.dialog.manage = true;
      },
      save(obj) {
        this.dialog.manage = false;
        if(this.single) {
          this.applianceService.updateFirmwareAppliance(this.personaltoken, this.selected.serialNumber, obj.force ? null : obj.desiredFirmware)
            .then((data) => {
              if(data.code=="200") {
                this.dialog.manageSuccess = true;
                this.reloadSingle();
              } else {
                console.error("ERROR "+JSON.stringify(data));
                this.dialog.error = true;
              }
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.dialog.error = true;
            });
        } else {
          this.applianceService.updateFirmwareModel(this.personaltoken, this.selected.modelId, obj.desiredFirmware, this.selected.brand, this.selected.country)
            .then((data) => {
              if(data.code=="200") {
                this.dialog.manageSuccess = true;
                this.reloadGlobal();
              } else {
                console.error("ERROR "+JSON.stringify(data));
                this.dialog.error = true;
              }
            })
            .catch(error => {
              console.error("EXCEPTION "+error);
              this.dialog.error = true;
            });
        }
      }
    }
}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

span.desired,
span.fota-all
 {
  color: #262626;
  font-style: italic;
}

</style>

<style>

</style>